var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "91px",
    viewBox: "0 0 91 91",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 0L11.3333 5.625L5.66667 5.625L5.66667 39.375L62.3333 39.375L62.3333 5.625L55.25 5.625L55.25 0L65.1667 0C66.6197 0 67.8173 1.08574 67.9809 2.4845L68 2.8125L68 42.1875C68 43.6298 66.9062 44.8186 65.4971 44.9811L65.1667 45L2.83333 45C1.3803 45 0.18273 43.9143 0.0190619 42.5155L0 42.1875L0 2.8125C0 1.37015 1.09378 0.181386 2.50291 0.0189217L2.83333 0L11.3333 0Z",
    transform: "translate(11 34)",
    id: "Path",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4223 0.579167C13.6554 -0.349627 15.4359 -0.138805 16.3993 1.05005C17.2885 2.14746 17.1706 3.69462 16.1774 4.65667L15.9109 4.8844L4.57772 13.4208C3.34463 14.3496 1.56406 14.1388 0.600715 12.9499C-0.288531 11.8525 -0.170616 10.3054 0.822644 9.34333L1.08912 9.1156L12.4223 0.579167Z",
    transform: "translate(11 26)",
    id: "Path-14",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.612 0.461133C13.9202 -0.390542 15.6767 -0.0288936 16.5352 1.2689C17.3324 2.47399 17.075 4.06252 15.9867 4.9652L15.7209 5.16085L4.38801 12.5389C3.07981 13.3905 1.32334 13.0289 0.464834 11.7311C-0.332353 10.526 -0.074964 8.93748 1.01329 8.0348L1.27908 7.83915L12.612 0.461133Z",
    transform: "matrix(-1 0 0 1 79 27)",
    id: "Path-14-Copy",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 0C43.6299 0 44.8186 1.09378 44.9811 2.50291L45 2.83333L45 48.1667C45 49.6197 43.9143 50.8173 42.5155 50.9809L42.1875 51L25.3125 51C23.7592 51 22.5 49.7315 22.5 48.1667C22.5 46.7136 23.5857 45.5161 24.9845 45.3524L25.3125 45.3333L39.375 45.3333L39.375 2.83333C39.375 1.3803 40.4607 0.18273 41.8595 0.0190619L42.1875 0ZM2.8125 0C4.25485 0 5.44361 1.09378 5.60608 2.50291L5.625 2.83333L5.625 48.1667C5.625 49.7315 4.3658 51 2.8125 51C1.37015 51 0.181386 49.9062 0.0189217 48.4971L0 48.1667L0 2.83333C0 1.26853 1.2592 0 2.8125 0Z",
    transform: "matrix(-1 0 0 -1 67 62)",
    id: "Shape",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 0L2.8 0C1.2536 0 0 1.2536 0 2.8L0 11.2C0 12.7464 1.2536 14 2.8 14L11.2 14C12.7464 14 14 12.7464 14 11.2L14 2.8C14 1.2536 12.7464 0 11.2 0ZM8.4 5.6L8.4 8.4L5.6 8.4L5.6 5.6L8.4 5.6Z",
    transform: "translate(31 25)",
    id: "Rectangle-Copy",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0C9.76878 0 11 1.34315 11 3C11 4.53851 9.93839 5.80652 8.57071 5.97982L8.25 6L2.75 6C1.23122 6 0 4.65685 0 3C0 1.46149 1.06161 0.193479 2.42929 0.0201832L2.75 0L8.25 0Z",
    transform: "translate(48 28)",
    id: "Path-4-Copy-2",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 0C26.7464 0 28 1.34315 28 3C28 4.53851 26.9191 5.80652 25.5265 5.97982L25.2 6L2.8 6C1.2536 6 0 4.65685 0 3C0 1.46149 1.08091 0.193479 2.47346 0.0201832L2.8 0L25.2 0Z",
    transform: "translate(31 45)",
    id: "Path-4-Copy",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5586 0.392671C33.3366 -0.0654451 34.2795 -0.12271 35.0987 0.220877L35.4414 0.392671L66.6076 18.7453C67.9548 19.5386 68.4016 21.27 67.6055 22.6125C66.8663 23.8591 65.3154 24.332 64.019 23.758L63.7249 23.6069L34 6.09871L4.27512 23.6069C3.02418 24.3435 1.43675 24.0122 0.578989 22.8863L0.394483 22.6125C-0.344709 21.3659 -0.0122872 19.7839 1.11759 18.9291L1.39236 18.7453L32.5586 0.392671Z",
    transform: "translate(11 55)",
    id: "Path-13",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5247 0L22 4.57382L3.4753 19L0 14.4262L18.5247 0Z",
    transform: "translate(56 48)",
    id: "Path-14",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5247 0L22 4.57382L3.4753 19L0 14.4262L18.5247 0Z",
    transform: "matrix(-1 0 0 1 34 48)",
    id: "Path-14",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "translate(50 11)",
    id: "Oval",
    fill: "#07A5DF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 0L90 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/results.00f6c73d7fa4ee235abd51f02a56b713.svg";
export { ForwardRef as ReactComponent };